import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarRatingProps {
  size?: 'sm' | 'lg';
  label?: string;
}
export function StarRating({
  size = 'sm',
  label = '5 out of 5 stars'
}: StarRatingProps) {
  const cls = size === 'lg' ? 'h-7 w-7' : 'h-5 w-5';
  return <div className="flex items-center gap-0.5" role="img" aria-label={label} data-id="element-439" data-mp="ze27c0zuen0d">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${cls} fill-gold text-gold`} aria-hidden="true" data-id="element-440" data-mp="1rzv1jm72otbj" data-mpi={i} />)}
    </div>;
}